import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

  transform(html): String {
    if (html) {
      return String(html).replace(/<[^>]+>/gm, '')
                         .replace(/&nbsp;/gm, '')
    } else {
      return "";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/strip-html.pipe.ts